export default __webpack_public_path__ + "static/media/star.e6785b4f.gif";